import { render, staticRenderFns } from "./GraphDetail08.vue?vue&type=template&id=05f9574f&scoped=true"
import script from "./GraphDetail08.vue?vue&type=script&lang=js"
export * from "./GraphDetail08.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f9574f",
  null
  
)

export default component.exports